/* unplugin-vue-components disabled */import script from "./PositionAllocation.vue?vue&type=script&setup=true&name=Medal&lang=js"
export * from "./PositionAllocation.vue?vue&type=script&setup=true&name=Medal&lang=js"

import "./PositionAllocation.vue?vue&type=style&index=0&id=1a5728ee&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5728ee"]])

export default __exports__